/**
 * Publications Modal
 */
var component_publications_modal = function (args) {
  // setup args
  var modal = args.modal,
    close_button = document.querySelector(".publications-modal__close-button"),
    dialog = new A11yDialog(modal);

  // validate
  if (!modal) {
    console.log("Invalid Publications Modal component");
    return;
  }

  var timeout = 300;
  var advertiser = false;
  // check if body has .advertiser-site and change timeout to 300
  if (document.body.classList.contains("advertiser-site")) {
    // smaller time because there's some weird flash otherwise
    advertiser = true;
  }

  /**
   * Init
   */
  function init_publications_modal() {
    dialog.on("show", () => {
      modal.classList.add("publications-modal--is-open");
    });

    close_button.addEventListener("click", () => {
      modal.classList.add("publications-modal--is-closing");

      setTimeout(() => {
        dialog.hide();
        modal.classList.remove("publications-modal--is-open");
        modal.classList.remove("publications-modal--is-closing");
      }, timeout);
    });

    return;
  }
  init_publications_modal();

  // make the call chainable
  return this;
};
